
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class ProductTagFilterModel extends Model<ProductTagFilterModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string', languageString: 'productTagFilter.property.tag' },
		{ name: 'parentTag', type: 'string', languageString: 'productTagFilter.property.parentTag' },
		{ name: 'inverseParentTagNavigation', type: 'ProductTagFilterModel[]', languageString: 'productTagFilter.property.inverseParentTagNavigation', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagNavigation', type: 'ProductTagFilterModel', languageString: 'productTagFilter.property.parentTagNavigation', isHidden: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagFilter', type: 'ProductTagFilterModel', languageString: 'productTagFilter.property.parentTagFilter', isHidden: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } },
		{ name: 'parentTagFilters', type: 'ProductTagFilterModel[]', languageString: 'productTagFilter.property.parentTagFilters', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagFilterModel }, properties: () => { return ProductTagFilterModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public parentTag: string;
	public inverseParentTagNavigation: ProductTagFilterModel[];
	public parentTagNavigation?: ProductTagFilterModel;
	public parentTagFilter?: ProductTagFilterModel;
	public parentTagFilters: ProductTagFilterModel[];
    
	constructor(){
		super();
		this.tag = '';
		this.parentTag = '';
		this.inverseParentTagNavigation = [];
		this.parentTagNavigation = undefined;
		this.parentTagFilter = undefined;
		this.parentTagFilters = [];
		
	}
	getProperties(){
		return ProductTagFilterModel.classProperties;
	}
}

